import { faEye, faEyeSlash, faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import ButtonIcon from "./ButtonIcon";
import ElementPositionEditor from "./ElementPositionEditor";

import styles from "./ElementListItem.module.css";

export type ElementActionsType = {
	onElementAdd: (element: ElementDefinitionType) => void;
	onElementRemove: (elementId: string) => void;
	onElementDefRemove: (elementId?: string) => void;
	onSelectElement: (elementId: string) => void;
	onUnselect: () => void;
	onElementMove: (axis: AxisEnum, value: number) => void;
	onElementRotate: (axis: RotationEnum, value: 1 | -1) => void;
};

const ElementListItem: React.FC<
	{
		element: ElementDefinitionType;
		elementInCanvas?: ContainerElementRef;
		selected?: boolean;
	} & ElementActionsType
> = ({
	element,
	elementInCanvas,
	selected,
	onElementAdd,
	onElementRemove,
	onSelectElement,
	onUnselect,
	onElementMove,
	onElementRotate,
	onElementDefRemove
}) => (
	<div className={styles.element}>
		<div className={styles.actions}>
			<div className={styles.label}>
				<div title={element.id}>{element.id}</div>
				<div className={styles.color} style={{ backgroundColor: element.color }}></div>
			</div>
			<div className={styles.infos}>{element.showInfos()}</div>
			{elementInCanvas && (
				<ButtonIcon
					icon={selected ? faEyeSlash : faEye}
					data-elementid={element.id}
					onClick={
						selected
							? onUnselect
							: e => onSelectElement(e.currentTarget.dataset.elementid || "")
					}
				/>
			)}
			{!elementInCanvas && (
				<ButtonIcon
					icon={faTrash}
					data-elementid={element.id}
					onClick={e => onElementDefRemove(e.currentTarget.dataset.elementid)}
				/>
			)}
			<ButtonIcon
				icon={elementInCanvas ? faMinus : faPlus}
				data-elementid={element.id}
				onClick={
					elementInCanvas
						? e => onElementRemove(e.currentTarget.dataset.elementid || "")
						: () => onElementAdd(element)
				}
			/>
		</div>
		{selected && elementInCanvas && (
			<div className={styles.editor}>
				<ElementPositionEditor
					element={elementInCanvas}
					onElementMove={onElementMove}
					onElementRotate={onElementRotate}
				/>
			</div>
		)}
	</div>
);

export default ElementListItem;
